<template>
  <div style="padding:100px 8%;">
    <div v-if="!isaddInsurance && !isEditInsurance">
      <section class="tab-pane" role="tabpanel">
        <div class="text-center">
          <a class="btn btn-primary" @click="addInsurance()">
          新增商品設定
          </a>
          <a class="btn btn-primary" @click="editInsurance()">
          修改商品設定
          </a>
        </div>
      </section>
      <h4>傳統型商品</h4>
      <section class="row" :class="{ 'section-loading': isLoading }">
        <table class="table datatable">
          <thead>
            <tr>
              <th style="width: 5%" class="text-center">編號</th>
              <th style="width: 15%" class="text-center">公司別</th>
              <th style="width: 30%" class="text-center">商品名稱</th>
              <th style="width: 20%" class="text-center">商品代碼</th>
              <th style="width: 10%" class="text-center">商品種類</th>
              <th style="width: 10%" class="text-center">處理狀態</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, i) in traditionData" :key="`tradition-data-${i}`">
              <td class="text-center">{{ i + 1 }}</td>
              <td>{{ data.compnm }}</td>
              <td>
                <a class="link text-underline" @click="editInsurance(data)">{{data.name}}</a>
              </td>
              <td class="text-center">{{ data.plan_code }}</td>
              <td class="text-center">{{ productType[data.producttype] }}</td>
              <td class="text-center">{{ statusType[data.status] }}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <h4>投資型商品</h4>
      <section class="row" :class="{ 'section-loading': isLoading }">
        <table class="table datatable">
          <thead>
            <tr>
              <th style="width: 5%" class="text-center">編號</th>
              <th style="width: 15%" class="text-center">公司別</th>
              <th style="width: 30%" class="text-center">商品名稱</th>
              <th style="width: 20%" class="text-center">商品代碼</th>
              <th style="width: 10%" class="text-center">商品種類</th>
              <th style="width: 10%" class="text-center">處理狀態</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, i) in investData" :key="`invest-data-${i}`">
              <td class="text-center">{{ i + 1 }}</td>
              <td>{{ data.compnm }}</td>
              <td>
                <a class="link text-underline" @click="editInsurance(data)">{{data.name}}</a>
              </td>
              <td class="text-center">{{ data.plan_code }}</td>
              <td class="text-center">{{ productType[data.producttype] }}</td>
              <td class="text-center">{{ statusType[data.status] }}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <h4>團險商品</h4>
      <section class="row" :class="{ 'section-loading': isLoading }">
        <table class="table datatable">
          <thead>
            <tr>
              <th style="width: 5%" class="text-center">編號</th>
              <th style="width: 15%" class="text-center">公司別</th>
              <th style="width: 30%" class="text-center">商品名稱</th>
              <th style="width: 20%" class="text-center">商品代碼</th>
              <th style="width: 10%" class="text-center">商品種類</th>
              <th style="width: 10%" class="text-center">處理狀態</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, i) in groupData" :key="`group-data-${i}`">
              <td class="text-center">{{ i + 1 }}</td>
              <td>{{ data.compnm }}</td>
              <td>
                <a class="link text-underline" @click="editInsurance(data)">{{data.name}}</a>
              </td>
              <td class="text-center">{{ data.plan_code }}</td>
              <td class="text-center">{{ productType[data.producttype] }}</td>
              <td class="text-center">{{ statusType[data.status] }}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
    <div v-if="isaddInsurance">
      <Insurance-Product-Add
        @close="submitInsurance()"
        />
    </div>
    <div v-if="isEditInsurance">
      <Insurance-Product-Edit
        :editProduct="editProduct"
        @close="submitInsurance()"
      />
    </div>
  </div>
</template>

<script>
import InsuranceProductAdd from "./InsuranceProductAdd";
import InsuranceProductEdit from "./InsuranceProductEdit";
import { getUnreleasedProduct } from "@/service";
import { commonMixin } from "@/mixins/common";
export default {
  name: "ProductMenuPage",
  mixins: [commonMixin],
  data() {
    return {
      traditionData: [],
      investData: [],
      groupData: [],
      editProduct: {},
      productType: {
        1: "傳統型",
        2: "投資型",
        3: "利率變動型",
        4: "傳統型(取大)",
        5: "團險",
      },
      statusType: { 0: "待覆核", 1: "待覆核", 2: "待發佈" },
      isLoading: false,
      isaddInsurance: false,
      isEditInsurance: false,
    };
  },
  components: {
    InsuranceProductAdd,
    InsuranceProductEdit,
  },
  methods: {
    init() {
      this.isLoading = true;
      getUnreleasedProduct(this.$store.state.userInfo.id).then((result) => {
        if (result.header && result.header.status == "200") {
          this.traditionData = result.data.traditional || [];
          this.investData = result.data.investment || [];
          this.groupData = result.data.group || [];
          window.$("html, body").scrollTop(0);
        } else {
          this.traditionData = [];
          this.investData = [];
          this.groupData = [];
          this.$toast.info({ title: result.header.message });
        }
        this.isLoading = false;
      });

      if (this.$route.params.isback) {
        this.editInsurance(JSON.parse(localStorage.editProduct));
        localStorage.editProduct = "";
      }
    },
    addInsurance() {
      this.isaddInsurance = true;
    },
    submitInsurance() {
      this.isaddInsurance = false;
      this.isEditInsurance = false;
      this.init();
    },
    editInsurance(data) {
      this.editProduct = data;
      this.isEditInsurance = true;
    },
  },
  mounted() {
    this.init();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path.includes("InvestFormula")) {
        let productData = JSON.parse(localStorage.productData);
        let editData = {
          companyid:productData.company.COMPANYID,
          contracttype:productData.contractType,
          producttype:productData.productType,
          productid:productData.productId,
          plan_code:productData.insuranceCode,
          name:productData.insuranceName
        }
        vm.editInsurance(editData);
      }
    });
  },
};
</script>
<style scoped>
* {
  user-select: text;
}
.table.datatable tbody tr > td:first-child {
  padding-left: 10px;
}
.table.datatable thead tr > th:first-child {
  padding-left: 10px;
}
</style>
